import React from 'react';
import { Link } from 'react-router-dom';

import MediaItemPreview from './MediaItemPreview';

const MediaItemPreviewContainer = ({
	index,
	mediaItem,
	linkType,
	handlePickItem,
	library,
	eventID,
}) => {
	const link =
		linkType === 'eventMedia'
			? `/events/${eventID}/media/${mediaItem.id}`
			: 'eventLibrary'
			? `/events/${eventID}/library/${mediaItem.id}`
			: '';

	const mediaItemPreview = (
		<MediaItemPreview mediaItem={mediaItem} handlePickItem={handlePickItem} />
	);

	const breadcrumbLibrary = library.name !== 'Materials' ? library : null;
	return (
		<div className="MediaItemPreviewContainer">
			{!handlePickItem && link ? (
				<Link
					to={{
						pathname: link,
						query: { library: library ? library : null },
					}}
					state={{ library: breadcrumbLibrary }}
					key={`mediaItem-${index}`}
				>
					{mediaItemPreview}
				</Link>
			) : (
				<div key={`mediaItem-${index}`}>{mediaItemPreview}</div>
			)}
		</div>
	);
};

export default MediaItemPreviewContainer;
